var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-tabbar',{staticClass:"tabbar",attrs:{"route":"","active-color":_vm.iconActiveColor,"inactive-color":_vm.inactiveColor}},_vm._l((_vm.tabList),function(item,index){return _c('van-tabbar-item',{key:index,attrs:{"replace":"","to":item.path,"name":index},scopedSlots:_vm._u([{key:"icon",fn:function(props){return [_c('svg-icon',{staticClass:"icons",style:({
          color: props.active
            ? _vm.activeColor
            : _vm.inactiveColor
        }),attrs:{"iconClass":item.icon}})]}}],null,true)},[_c('span',[_vm._v(_vm._s(item.name))])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }